import {
    ajax
} from '@/utils/request'
// 获取分类
export function classify() {
    return ajax('api/v1/goodsCategory/h5/tree')
}